module.exports = __webpack_public_path__ + "img/vonestis_main_01.a8e2c3bb.jpg";